import React, { useState } from 'react';
import { Modal, Upload, Button, message, Table, Space } from 'antd';
import { UploadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import ColaboradorService from 'services/ColaboradorService';

export function ModalActualizarEstadoRegistro({ visible, onCancel, onSuccess }) {
    const [archivo, setArchivo] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [preview, setPreview] = useState([]);
    const [showPreview, setShowPreview] = useState(false);

    const propsUpload = {
        onRemove: () => {
            setArchivo(null);
            setPreview([]);
            setShowPreview(false);
        },
        beforeUpload: (file) => {
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                         || file.type === 'application/vnd.ms-excel';
            
            if (!isExcel) {
                message.error('Solo se permiten archivos Excel (.xlsx, .xls)');
                return false;
            }
            
            setArchivo(file);
            return false;
        },
        maxCount: 1,
        accept: '.xlsx,.xls',
    };

    const handlePrevisualizar = async () => {
        if (!archivo) {
            message.warning('Debe seleccionar un archivo');
            return;
        }

        try {
            setCargando(true);
            const formData = new FormData();
            formData.append('archivo', archivo);
            
            // const resultado = await ColaboradorService.previsualizarActualizacionEstado(formData);
            // setPreview(resultado);
            // setShowPreview(true);
            // setCargando(false);
        } catch (error) {
            message.error('Error al previsualizar: ' + error.response?.data?.mensaje);
            setCargando(false);
        }
    };

    const handleActualizar = async () => {
        if (!archivo) {
            message.warning('Debe seleccionar un archivo');
            return;
        }

        try {
            setCargando(true);
            const formData = new FormData();
            formData.append('archivo', archivo);
            
            const resultado = await ColaboradorService.actualizarEstadoRegistroMasivo(formData);
            
             //message.success(`Actualización exitosa: ${resultado.actualizados} colaboradores actualizados`);
            message.success(`Colaboradores actualizados`);
            // if (resultado.noEncontrados > 0) {
            //     message.warning(`${resultado.noEncontrados} documentos no fueron encontrados`);
            // }
            
            setCargando(false);
            setArchivo(null);
            setPreview([]);
            setShowPreview(false);
            onSuccess();
            onCancel();
        } catch (error) {
            message.error('Error al actualizar: ' + error.response?.data?.mensaje);
            setCargando(false);
        }
    };

    const columnas = [
        {
            title: 'N°',
            dataIndex: 'index',
            key: 'index',
            width: 60,
            render: (text, record, index) => index + 1
        },
        {
            title: 'Documento',
            dataIndex: 'documentoIdentidad',
            key: 'documentoIdentidad',
        },
        {
            title: 'Estado Registro',
            dataIndex: 'estadoRegistro',
            key: 'estadoRegistro',
        },
        {
            title: 'Estado',
            dataIndex: 'encontrado',
            key: 'encontrado',
            render: (encontrado) => (
                encontrado ? (
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 18 }} />
                ) : (
                    <CloseCircleOutlined style={{ color: 'red', fontSize: 18 }} />
                )
            )
        }
    ];

    return (
        <Modal
            title="Actualizar Estado Masivo"
            open={visible}
            onCancel={onCancel}
            width={800}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Cancelar
                </Button>,
                // <Button 
                //     key="previsualizar" 
                //     onClick={handlePrevisualizar} 
                //     loading={cargando}
                //     disabled={!archivo}
                // >
                //     Previsualizar
                // </Button>,
                <Button 
                    key="actualizar" 
                    type="primary" 
                    onClick={handleActualizar} 
                    loading={cargando}
                    disabled={!archivo}
                >
                    Actualizar
                </Button>
            ]}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="large">
                <div>
                    <p><strong>Formato del archivo Excel:</strong></p>
                    <ul>
                        <li>Columna 1: <code>NUMERO_DOCUMENTO_IDENTIDAD</code></li>
                        <li>Columna 2: <code>ESTADO_COLABORADOR</code> (valores permitidos: ACTIVO, CESADO, ONBOARDING)</li>
                        <li>Columna 3: <code>ACCESO_PLATAFORMA</code> (valores permitidos: SI, NO)</li>
                    </ul>
                </div>

                <Upload {...propsUpload}>
                    <Button icon={<UploadOutlined />}>Seleccionar archivo Excel</Button>
                </Upload>

                {showPreview && preview.length > 0 && (
                    <div>
                        <h4>Vista previa ({preview.length} registros)</h4>
                        <Table 
                            columns={columnas} 
                            dataSource={preview} 
                            pagination={{ pageSize: 5 }}
                            size="small"
                            rowKey={(record) => record.documentoIdentidad}
                        />
                    </div>
                )}
            </Space>
        </Modal>
    );
}
